import apiService from '../apiService';

/**
 * 獲取管理者的所有權限
 * @param {number} managerId - 管理者 ID
 * @returns {Promise} API 響應
 */
export const getManagerPermissions = async (managerId) => {
    const url = `/api/admin/user-roles/manager/${managerId}/permissions`;
    return apiService.GET(url);
};

/**
 * 為管理者分配角色
 * @param {number} managerId - 管理者 ID
 * @param {Array<number>} roleIds - 角色 ID 陣列
 * @returns {Promise} API 響應
 */
export const assignManagerRoles = async (managerId, roleIds) => {
    const url = `/api/admin/user-roles/manager/${managerId}/roles`;
    const data = { role_ids: roleIds };
    return apiService.POST(url, data);
};

/**
 * 移除管理者的指定角色
 * @param {number} managerId - 管理者 ID
 * @param {number} roleId - 角色 ID
 * @returns {Promise} API 響應
 */
export const removeManagerRole = async (managerId, roleId) => {
    const url = `/api/admin/user-roles/manager/${managerId}/role/${roleId}`;
    return apiService.DELETE(url);
};
